<template>
  <component
    :is="as"
    :class="{
      'text-page-header font-bold md:text-page-header-desktop': variant === 'page-header',
      'text-header-1 font-bold md:text-header-1-desktop': variant === 'header-1',
      'text-header-2 font-bold md:text-header-1-desktop': variant === 'section-title',
      'text-header-2 font-bold md:text-header-2-desktop': variant === 'header-2',
      'text-header-3 font-bold md:text-header-3-desktop': variant === 'header-3',
      'text-header-4 font-bold md:text-header-4-desktop': variant === 'header-4',
      'text-header-5 font-bold md:text-header-5-desktop': variant === 'header-5',
      'text-header-6 font-bold md:text-header-6-desktop': variant === 'header-6',
      'text-header-7 font-bold md:text-header-7-desktop': variant === 'header-7',
      'text-header-8 font-bold md:text-header-8-desktop': variant === 'header-8',
      'text-header-card font-bold md:text-header-card-desktop': variant === 'header-card',
      'text-header-5 font-bold md:text-[18px] leading-[25px]': variant === 'location-card-header',
      'text-body-intro md:text-body-intro-desktop': variant === 'body-intro',
      'text-body-large': variant === 'body-large',
      'text-body-medium lg:text-body-medium-desktop': variant === 'body-medium',
      'text-body-small': variant === 'body-small',
      'text-body-extra-small': variant === 'body-extra-small',
      'text-main-article md:text-main-article-desktop': variant === 'main-article',
      'text-body': variant === 'body',
      'text-body font-bold': variant === 'body-bold',
      'text-caption md:text-caption-desktop': variant === 'caption',
      'text-caption-bold font-bold': variant === 'caption-bold',
      'text-caption-small md:text-caption-small-desktop': variant === 'caption-small',
      'text-navigation-sub': variant === 'navigation-sub',
      'text-main-condensed-lh md:text-main-condensed-lh-desktop': variant === 'main-text-condensed-lh',
      'text-main-condensed-lh': variant === 'main-text-condensed-lh-mobile',
      'text-body-extra-small md:text-body-small': variant === 'footer-linklist',
      'text-header-8': variant === 'footer-bulletlist',
      'text-header-6 lg:text-header-4-desktop': variant === 'cross-domain-title',
      'text-caption-small lg:text-header-5': variant === 'cross-domain-link',
      'text-usp md:text-usp-desktop': variant === 'text-usp',
      'font-bold md:text-scroll-md lg:text-scroll-lg xl:text-scroll-xl': variant === 'domain-scroll-title',
      'md:text-scroll-body-md lg:text-scroll-body-lg xl:text-scroll-body-xl': variant === 'domain-scroll-body',
    }">
    <slot />
  </component>
</template>

<script lang="ts" setup>
export type TypographyVariant =
  | 'page-header'
  | 'header-1'
  | 'section-title'
  | 'header-2'
  | 'header-3'
  | 'header-4'
  | 'header-5'
  | 'header-6'
  | 'header-7'
  | 'header-8'
  | 'header-card'
  | 'location-card-header'
  | 'body-intro'
  | 'body-large'
  | 'body-medium'
  | 'body-extra-small'
  | 'body'
  | 'body-bold'
  | 'body-small'
  | 'main-article'
  | 'caption'
  | 'caption-bold'
  | 'caption-small'
  | 'navigation-sub'
  | 'main-text-condensed-lh'
  | 'footer-linklist'
  | 'footer-bulletlist'
  | 'cross-domain-title'
  | 'cross-domain-link'
  | 'text-usp'
  | 'main-text-condensed-lh-mobile'
  | 'domain-scroll-title'
  | 'domain-scroll-body'

defineProps<{
  as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div' | 'label' | 'header'
  variant: TypographyVariant
}>()
</script>
